import { createElement } from '@syncfusion/ej2-base';
export class HeadingRenderer {
    constructor(manager) {
        this.parent = manager;
    }
    /**
     * Renders heading block
     *
     * @param {BlockModel} block - specifies the block.
     * @returns {HTMLElement} - the created or updated element
     * @hidden
     */
    renderHeading(block) {
        const headingProps = block.properties;
        headingProps.placeholder = this.parent.getPlaceholderValue(block);
        const heading = createElement(`h${headingProps.level}`, {
            attrs: {
                contenteditable: 'true',
                placeholder: headingProps.placeholder
            }
        });
        this.parent.blockRenderer.contentRenderer.renderContent(block, heading);
        return heading;
    }
}
